import React, { useState } from 'react';

const ActivoForm = ({ onAdd }) => {
  const [nombre, setNombre] = useState('');
  const [categoria, setCategoria] = useState('');
  const [valor, setValor] = useState('');
  const [vida, setVida] = useState('');
  const [foto, setFoto] = useState(null);
  const [factura, setFactura] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (nombre && categoria && valor && vida) {
      onAdd({
        nombre,
        categoria,
        valor: parseFloat(valor),
        vida: parseInt(vida),
        foto: foto ? URL.createObjectURL(foto) : null,
        factura: factura ? factura.name : null,
      });
      setNombre('');
      setCategoria('');
      setValor('');
      setVida('');
      setFoto(null);
      setFactura(null);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input className="input" type="text" placeholder="Nombre del activo" value={nombre} onChange={e => setNombre(e.target.value)} />
      <input className="input" type="text" placeholder="Categoría (Ej: Computadora)" value={categoria} onChange={e => setCategoria(e.target.value)} />
      <input className="input" type="number" placeholder="Valor de compra" value={valor} onChange={e => setValor(e.target.value)} />
      <input className="input" type="number" placeholder="Vida útil (años)" value={vida} onChange={e => setVida(e.target.value)} />
      <input className="input" type="file" accept="image/*" onChange={e => setFoto(e.target.files[0])} />
      <input className="input" type="file" accept="application/pdf" onChange={e => setFactura(e.target.files[0])} />
      <button className="boton" type="submit">Agregar Activo</button>
    </form>
  );
};

export default ActivoForm;